import React, { useContext } from 'react';
import ThemeContext from '../context/ThemeContext';
import './style/Header.css';
import './style/dark-mode/HeaderDark.css';
import PerfilFoto from './images-header/PerfilFoto.png';
import lightMode from './images-header/light-mode.png';
import darkMode from './images-header/dark-mode.png';


function Header() {
    const {theme, toggleTheme} = useContext(ThemeContext);

    return(
        
        <head className={`header-container header-container-${theme}`}>
            <div className="perfil-container">   
                <img src={PerfilFoto} alt="" width='65px' />
                <h1>EBIO NARDUCHE</h1>
            </div>
            <nav className={`navigation-container navigation-container-${theme}`}>
                <a href="#home">INÍCIO</a>
                <a href="#about" >SOBRE</a>
                <a href="#projects">PROJETOS</a> 
                <a href='#contact'>CONTATO</a>
                {
                    theme === 'light' ? 
                        <img 
                            src={lightMode} 
                            onClick={toggleTheme}
                            width='55px'   
                        /> :
                        <img 
                            src={darkMode} 
                            onClick={toggleTheme}
                            width='38px'   
                        />
                }
            </nav>
        </head>
    );
}

export default Header;